import React, { useState } from "react";
import {
  BtnDiv1,
  DoneDiv,
  QuestionDiv,
  TextContent,
} from "./stakingpopupElements";
import { GoDotFill } from "react-icons/go";
import { cancelbtn, connectbtnimg } from "assets";
import { Image } from "react-bootstrap";
import { FaSquareCheck } from "react-icons/fa6";

const TabsContent = ({ stakeNft, confirmtext, days }) => {
  const [staketext, setStaketext] = useState(false);

  const showText = () => {
    setStaketext(true);
  };
  const web3Call = async () => {
    try {
      await stakeNft();
    } catch (error) {}
  };
  return (
    <div>
      <TextContent>
        <h5>
          <GoDotFill /> Receive <span>{days} Voxel Energy</span>{" "}
        </h5>
        <h5>
          <GoDotFill /> Activate VIP tasks for more pool share points
        </h5>
        <h5>
          <GoDotFill /> Activate special in-game items / vehicles /<br />{" "}
          weapons
        </h5>
        <h5>
          <GoDotFill /> Tokens / In-game items Airdrop (Powering Up)
        </h5>
      </TextContent>
      {staketext ? (
        <>
          {confirmtext ? (
            <DoneDiv>
              <h1>
                <FaSquareCheck /> STAKING DONE!
              </h1>
            </DoneDiv>
          ) : (
            <>
              <QuestionDiv>
                <p>Are you sure you want to Stake this NFT for {days} days?</p>
                <div className="btn-wrapper">
                  <div className="register-btn-div">
                    <Image
                      src={connectbtnimg}
                      alt="button img"
                      className="btn-img"
                    />

                    <h1 onClick={() => web3Call()}>Confirm</h1>
                  </div>
                  <div className="register-btn-div">
                    <Image
                      src={cancelbtn}
                      alt="button img"
                      className="btn-img"
                    />

                    <h5>Cancel</h5>
                  </div>
                </div>
              </QuestionDiv>
            </>
          )}
        </>
      ) : (
        <>
          <BtnDiv1>
            <div className="register-btn-div" onClick={showText}>
              <Image src={connectbtnimg} alt="button img" className="btn-img" />

              <h1>Stake Now</h1>
            </div>
          </BtnDiv1>
        </>
      )}
    </div>
  );
};

export default TabsContent;
